import styled, { keyframes } from 'styled-components/macro'
import { Overlay } from 'styles/misc'

const zoomIn = keyframes`
  to { transform: scale(1.15) }
`

export const MainImage = styled.img`
  ${Overlay}
  width: 100%;
  object-fit: cover;
  animation: 6s ${zoomIn} linear;
`
